enum ReadyState {
  PENDING = 'PENDING',
  LOADING = 'LOADING',
  FULFILLED = 'FULFILLED',
  REJECTED = 'REJECTED',
}

export default ReadyState;
